let wx = require('weixin-js-sdk')
let share = (obj, share_obj, _this, link) => {
  wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: obj.appId, // 必填，公众号的唯一标识
      timestamp: obj.timestamp, // 必填，生成签名的时间戳
      nonceStr: obj.nonceStr, // 必填，生成签名的随机串
      signature: obj.signature,// 必填，签名
      jsApiList: ['checkJsApi', 'updateAppMessageShareData','updateTimelineShareData','onMenuShareAppMessage','onMenuShareTimeline'] // 必填，需要使用的JS接口列表
  })
  // checkJsApi接口是客户端6.0.2新引入的一个预留接口，第一期开放的接口均可不使用checkJsApi来检测。
  // console.log(obj)
  // console.log(share_obj)
  let checkResult
  wx.checkJsApi({
    jsApiList: ['updateAppMessageShareData','updateTimelineShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
    success: function(res) {
      // alert(typeof(res.checkResult))
      // alert(res.checkResult)
      checkResult = res.checkResult
      wx.ready(function(){
          // if (checkResult.updateAppMessageShareData) {
            wx.updateAppMessageShareData({
              title: share_obj.title,
              desc: share_obj.desc,
              link: link,
              imgUrl: share_obj.imgUrl
            })
            // 发送给好友
            WeixinJSBridge.on('menuItem:share:appMessage', function(argv){
              WeixinJSBridge.invoke('sendAppMessage',{
                appid: obj.appId,
                desc: share_obj.desc,
                link: link,
                imgUrl: share_obj.imgUrl,
                title: share_obj.title
              }, function(res) {
                _czc.push(['_trackEvent', '手机端分享专题', '分享专题给朋友（'+share_obj.title+'）'])
              })
            })
          // }
          // if (checkResult.updateTimelineShareData) {
            wx.updateTimelineShareData({ // 分享到朋友圈
              title: share_obj.title, // 分享标题
              link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: share_obj.imgUrl // 分享图标
            })
            // 分享到朋友圈
            WeixinJSBridge.on('menuItem:share:timeline', function(argv){
              WeixinJSBridge.invoke('shareTimeline',{
                  appid: obj.appId,
                  desc: share_obj.desc,
                  link: link,
                  imgUrl: share_obj.imgUrl,
                  title: share_obj.title
              }, function(res) {
                _czc.push(['_trackEvent', '手机端分享专题', '分享专题到朋友圈（'+share_obj.title+'）'])
              })
            })
          // }
          wx.onMenuShareAppMessage({
            title: share_obj.title,
            desc: share_obj.desc,
            link: link,
            imgUrl: share_obj.imgUrl
          })
          // 发送给好友
          WeixinJSBridge.on('menu:share:appmessage', function(argv){
            WeixinJSBridge.invoke('sendAppMessage',{
              appid: obj.appId,
              desc: share_obj.desc,
              link: link,
              imgUrl: share_obj.imgUrl,
              title: share_obj.title
            }, function(res) {
              _czc.push(['_trackEvent', '手机端分享专题', '分享专题给朋友（'+share_obj.title+'）'])
            })
          })
          wx.onMenuShareTimeline({ // 分享到朋友圈
            title: share_obj.title, // 分享标题
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share_obj.imgUrl // 分享图标
          })
          // 分享到朋友圈
          WeixinJSBridge.on('menu:share:timeline', function(argv){
            WeixinJSBridge.invoke('shareTimeline',{
                appid: obj.appId,
                desc: share_obj.desc,
                link: link,
                imgUrl: share_obj.imgUrl,
                title: share_obj.title
            }, function(res) {
              _czc.push(['_trackEvent', '手机端分享专题', '分享专题到朋友圈（'+share_obj.title+'）'])
            })
          })
      })
      wx.error((res) => {
        console.log('微信分享初始化错误！')
      })
    }
  })
}

export { share }
